import React from 'react'
import PropTypes from 'prop-types'

import stateInfoItemContainer from './stateInfoItemContainer'
import './StateInfoItem.css'

export const StateInfoItem = ({ stateInfo }) => {
  if (!stateInfo) {
    return null
  }

  return (
    <div className='list-group-item list-group-item-secondary StateInfoItem'>
      {stateInfo.secretary_of_state_url ? (
        <p className='small'>For more information, visit the <a href={stateInfo.secretary_of_state_url} rel="noopener noreferrer" target='_blank' title={`${stateInfo.name} Secretary of State website`}>{stateInfo.name} Secretary of State's website</a>.</p>
      ) : (
        <p className='small'>For more information, contact the {stateInfo.name} Secretary of State.</p>
      )}
    </div>
  )
}

StateInfoItem.propTypes = {
  stateInfo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    secretary_of_state_url: PropTypes.string,
  }),
}

export default stateInfoItemContainer(StateInfoItem)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/StateInfoItem/StateInfoItem.js